import { render, staticRenderFns } from "./det-pedido.vue?vue&type=template&id=6a56f41d&"
import script from "./det-pedido.vue?vue&type=script&lang=js&"
export * from "./det-pedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports